<template>
  <div class="bq-page" :class="{ 'bq-page-wirelss': isMobile }">
    <banner
      :cover="banner.cover"
      :mcover="banner.mcover"
      :title="banner.title"
    />

    <tab
      class="bq-tabs"
      :tabs="tabsData"
      :clickCallback="handleTabClick"
      :default-active="defaultTabActive"
    />
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import Tab from '@/components/Tab';
import { banner, serviceData } from './service.js';
import { isWirelessDevice } from '../../../utils/utils.js';
import { brushServeUrl } from '../../../defaultSettings';

export default {
  name: 'service',

  components: {
    Banner,
    Tab,
  },

  data() {
    return {
      isMobile: false,
      banner,
      serviceData,
      tabsData: serviceData.products.map(el => ({
        title: el.title,
        icon: el.icon,
        class: el.class,
        path: el.path,
        content: el.content,
        tab: el.tab,
      })),
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  computed: {
    defaultTabActive() {
      return this.$route.query.post ? Number(this.$route.query.post) - 1 : 0;
    },
  },

  methods: {
    handleTabClick(item) {
      if (!item.path) {
        return;
      }

      if (item.tab === 'face') {
        window.open(brushServeUrl, '_blank');

        return;
      }

      location.href = item.path;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
